var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictoPrint(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "45px",
    height: "43px",
    viewBox: "0 0 45 43",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Slice 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7221792,38 L33.2222332,38 C36.7532821,37.9863819 39.8280684,35.586089 40.6982766,32.1639218 C41.5684849,28.7417545 40.0137683,25.1642452 36.9181346,23.4655564 L34.5683996,25.818752 C36.7634738,26.4920128 38.1371051,28.6682814 37.8005348,30.9394818 C37.4639645,33.2106823 35.5182235,34.8950515 33.2222332,34.9027793 L16.7221792,34.9027793 C14.4224642,34.8989059 12.4719194,33.2125158 12.1357779,30.9374964 C11.7996365,28.6624771 13.1791436,26.484061 15.3794734,25.8152914 L13.0297384,23.4620958 C9.92871105,25.1567385 8.36892876,28.7362954 9.23905797,32.1613588 C10.1091872,35.5864223 13.1883283,37.9874718 16.7221792,37.9965394 L16.7221792,38 Z",
    id: "Path",
    fill: "#692B93",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4218656,6 L23.4218656,23.4240294 L19.3003126,19.2955553 L17.1166855,21.4861036 L23.8786624,28.2550016 C24.1676931,28.545577 24.5606311,28.7089511 24.9704759,28.7089511 C25.3803208,28.7089511 25.7732588,28.545577 26.0622895,28.2550016 L32.8208058,21.4861036 L30.6371786,19.2955553 L26.5156257,23.4240294 L26.5156257,6 L23.4218656,6 Z",
    id: "Path",
    fill: "#692B93",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoPrint);
export default __webpack_public_path__ + "static/media/picto-print.ad652a9a.svg";
export { ForwardRef as ReactComponent };